import { render, staticRenderFns } from "./CarrinhoDetalhes.vue?vue&type=template&id=eb1574e2"
import script from "./CarrinhoDetalhes.vue?vue&type=script&lang=js"
export * from "./CarrinhoDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports